import React from 'react';
import { IconButton, Link, ScreenContainer, withTheme } from '@draftbit/ui';
import { Text, View } from 'react-native';
import * as GlobalStyles from '../GlobalStyles.js';
import ScreenSizeWarningBlock from '../components/ScreenSizeWarningBlock';
import * as GlobalVariables from '../config/GlobalVariableContext';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import useWindowDimensions from '../utils/useWindowDimensions';

const defaultProps = { navigated: '' };

const GetStartedScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const [visibleFaq, setVisibleFaq] = React.useState(false);

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={true}
      style={StyleSheet.applyWidth(
        {
          backgroundColor: {
            minWidth: Breakpoints.Desktop,
            value:
              Constants['SWITCH_SCREEN_MODE'] === false
                ? palettes.Brand.Background
                : palettes.Brand.White,
          },
        },
        dimensions.width
      )}
    >
      {/* Container */}
      <>
        {!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <View
            style={StyleSheet.applyWidth(
              {
                alignItems: [
                  { minWidth: Breakpoints.Desktop, value: 'center' },
                  { minWidth: Breakpoints.Laptop, value: 'center' },
                ],
                flex: [
                  { minWidth: Breakpoints.Desktop, value: 1 },
                  { minWidth: Breakpoints.Laptop, value: 1 },
                ],
                gap: [
                  { minWidth: Breakpoints.Desktop, value: 50 },
                  { minWidth: Breakpoints.Laptop, value: 50 },
                ],
              },
              dimensions.width
            )}
          >
            {/* Header */}
            <View
              style={StyleSheet.applyWidth(
                {
                  alignItems: { minWidth: Breakpoints.Laptop, value: 'center' },
                  gap: { minWidth: Breakpoints.Laptop, value: 32 },
                  marginTop: { minWidth: Breakpoints.Laptop, value: 40 },
                },
                dimensions.width
              )}
            >
              {/* Let's Get Started! */}
              <Text
                accessible={true}
                selectable={false}
                {...GlobalStyles.TextStyles(theme)['Text'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.TextStyles(theme)['Text'].style,
                    {
                      color: [
                        {
                          minWidth: Breakpoints.Laptop,
                          value: palettes.Brand.White,
                        },
                        {
                          minWidth: Breakpoints.Desktop,
                          value: palettes.Brand.White,
                        },
                        {
                          minWidth: Breakpoints.Desktop,
                          value:
                            Constants['SWITCH_SCREEN_MODE'] === false
                              ? palettes.Brand.White
                              : undefined,
                        },
                        {
                          minWidth: Breakpoints.Laptop,
                          value:
                            Constants['SWITCH_SCREEN_MODE'] === false
                              ? palettes.Brand.White
                              : undefined,
                        },
                      ],
                      fontFamily: [
                        {
                          minWidth: Breakpoints.Desktop,
                          value: 'Inter_400Regular',
                        },
                        {
                          minWidth: Breakpoints.Laptop,
                          value: 'OpenSans_500Medium',
                        },
                      ],
                      fontSize: [
                        { minWidth: Breakpoints.Desktop, value: 30 },
                        { minWidth: Breakpoints.Laptop, value: 30 },
                      ],
                    }
                  ),
                  dimensions.width
                )}
              >
                {"Let's Get Started!"}
              </Text>
              {/* Header */}
              <Text
                accessible={true}
                selectable={false}
                {...GlobalStyles.TextStyles(theme)['Text'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.TextStyles(theme)['Text'].style,
                    {
                      color: {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.App['App Blue Light'],
                      },
                      fontFamily: {
                        minWidth: Breakpoints.Laptop,
                        value: 'OpenSans_500Medium',
                      },
                      fontSize: { minWidth: Breakpoints.Laptop, value: 20 },
                    }
                  ),
                  dimensions.width
                )}
              >
                {'It’s as easy as 1,2,3'}
              </Text>
            </View>
            {/* Text Group */}
            <View
              style={StyleSheet.applyWidth(
                {
                  gap: [
                    { minWidth: Breakpoints.Desktop, value: 30 },
                    { minWidth: Breakpoints.Laptop, value: 30 },
                  ],
                  width: [
                    { minWidth: Breakpoints.Desktop, value: '70%' },
                    { minWidth: Breakpoints.Laptop, value: '70%' },
                  ],
                },
                dimensions.width
              )}
            >
              {/* 1.Group */}
              <View
                {...GlobalStyles.ViewStyles(theme)['Get Started View'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.ViewStyles(theme)['Get Started View'].style,
                    {
                      backgroundColor: [
                        {
                          minWidth: Breakpoints.Desktop,
                          value:
                            Constants['SWITCH_SCREEN_MODE'] === false
                              ? palettes.Brand.White
                              : undefined,
                        },
                        {
                          minWidth: Breakpoints.Laptop,
                          value:
                            Constants['SWITCH_SCREEN_MODE'] === false
                              ? palettes.Brand.White
                              : palettes.Brand['App Purple'],
                        },
                      ],
                    }
                  ),
                  dimensions.width
                )}
              >
                <Text
                  accessible={true}
                  selectable={false}
                  {...GlobalStyles.TextStyles(theme)['Get Started Text'].props}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.TextStyles(theme)['Get Started Text'].style,
                      {
                        color: { minWidth: Breakpoints.Desktop, value: null },
                        fontFamily: {
                          minWidth: Breakpoints.Desktop,
                          value: null,
                        },
                        fontSize: {
                          minWidth: Breakpoints.Desktop,
                          value: null,
                        },
                      }
                    ),
                    dimensions.width
                  )}
                >
                  {
                    '1. From the dashboard side bar. Navigate to the income page and add your forecasted monthly income, and submit.'
                  }
                </Text>
              </View>
              {/* 1.Group 2 */}
              <View
                {...GlobalStyles.ViewStyles(theme)['Get Started View'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.ViewStyles(theme)['Get Started View'].style,
                    {
                      backgroundColor: [
                        {
                          minWidth: Breakpoints.Desktop,
                          value:
                            Constants['SWITCH_SCREEN_MODE'] === false
                              ? palettes.Brand.White
                              : undefined,
                        },
                        {
                          minWidth: Breakpoints.Laptop,
                          value:
                            Constants['SWITCH_SCREEN_MODE'] === false
                              ? palettes.Brand.White
                              : palettes.Brand['App Purple'],
                        },
                      ],
                    }
                  ),
                  dimensions.width
                )}
              >
                <Text
                  accessible={true}
                  selectable={false}
                  {...GlobalStyles.TextStyles(theme)['Get Started Text'].props}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.TextStyles(theme)['Get Started Text'].style,
                      {
                        color: [
                          {
                            minWidth: Breakpoints.Desktop,
                            value:
                              Constants['SWITCH_SCREEN_MODE'] === false
                                ? undefined
                                : palettes.Brand.White,
                          },
                          {
                            minWidth: Breakpoints.Laptop,
                            value:
                              Constants['SWITCH_SCREEN_MODE'] === false
                                ? undefined
                                : palettes.Brand.White,
                          },
                        ],
                      }
                    ),
                    dimensions.width
                  )}
                >
                  {
                    '2. When completed, navigate to the expense page and add your forecasted monthly expenses, and submit.'
                  }
                </Text>
              </View>
              {/* 1.Group 3 */}
              <View
                {...GlobalStyles.ViewStyles(theme)['Get Started View'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.ViewStyles(theme)['Get Started View'].style,
                    {
                      backgroundColor: [
                        {
                          minWidth: Breakpoints.Desktop,
                          value:
                            Constants['SWITCH_SCREEN_MODE'] === false
                              ? palettes.Brand.White
                              : undefined,
                        },
                        {
                          minWidth: Breakpoints.Laptop,
                          value:
                            Constants['SWITCH_SCREEN_MODE'] === false
                              ? palettes.Brand.White
                              : palettes.Brand['App Purple'],
                        },
                      ],
                    }
                  ),
                  dimensions.width
                )}
              >
                <Text
                  accessible={true}
                  selectable={false}
                  {...GlobalStyles.TextStyles(theme)['Get Started Text'].props}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.TextStyles(theme)['Get Started Text'].style,
                      {
                        color: [
                          {
                            minWidth: Breakpoints.Desktop,
                            value:
                              Constants['SWITCH_SCREEN_MODE'] === false
                                ? undefined
                                : palettes.Brand.White,
                          },
                          {
                            minWidth: Breakpoints.Laptop,
                            value:
                              Constants['SWITCH_SCREEN_MODE'] === false
                                ? undefined
                                : palettes.Brand.White,
                          },
                        ],
                      }
                    ),
                    dimensions.width
                  )}
                >
                  {
                    '3. After submitting both your forecasted monthly income and expenses, you can view a snapshot on your Dashboard, or the more detailed view on your Overview.'
                  }
                </Text>
              </View>
              {/* View 2 */}
              <View
                style={StyleSheet.applyWidth(
                  {
                    alignItems: [
                      { minWidth: Breakpoints.Laptop, value: 'center' },
                      { minWidth: Breakpoints.Desktop, value: 'center' },
                    ],
                    flexDirection: [
                      { minWidth: Breakpoints.Laptop, value: 'row' },
                      { minWidth: Breakpoints.Desktop, value: 'row' },
                    ],
                    gap: { minWidth: Breakpoints.Laptop, value: 12 },
                    justifyContent: [
                      { minWidth: Breakpoints.Laptop, value: 'center' },
                      { minWidth: Breakpoints.Desktop, value: 'center' },
                    ],
                  },
                  dimensions.width
                )}
              >
                {/* FAQ */}
                <Text
                  accessible={true}
                  selectable={false}
                  {...GlobalStyles.TextStyles(theme)['Header'].props}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.TextStyles(theme)['Header'].style,
                      {
                        color: {
                          minWidth: Breakpoints.Laptop,
                          value: palettes.App['App Blue Light'],
                        },
                        fontFamily: {
                          minWidth: Breakpoints.Laptop,
                          value: 'OpenSans_400Regular',
                        },
                        fontSize: { minWidth: Breakpoints.Laptop, value: 26 },
                      }
                    ),
                    dimensions.width
                  )}
                >
                  {'FAQ'}
                </Text>
              </View>
              {/* 4.Group */}
              <View
                {...GlobalStyles.ViewStyles(theme)['Get Started View'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.ViewStyles(theme)['Get Started View'].style,
                    {
                      backgroundColor: {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.App['App Blue Light'],
                      },
                    }
                  ),
                  dimensions.width
                )}
              >
                <Text
                  accessible={true}
                  selectable={false}
                  {...GlobalStyles.TextStyles(theme)['Get Started Text'].props}
                  style={StyleSheet.applyWidth(
                    GlobalStyles.TextStyles(theme)['Get Started Text'].style,
                    dimensions.width
                  )}
                >
                  {
                    'Want access on the go: Use your mobile view for quick access to starting and ending balances, as well as,  annual or monthly forecasted  income and expenses.'
                  }
                </Text>
              </View>
              {/* 5.Group */}
              <View
                {...GlobalStyles.ViewStyles(theme)['Get Started View'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.ViewStyles(theme)['Get Started View'].style,
                    {
                      backgroundColor: {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.App['App Blue Light'],
                      },
                    }
                  ),
                  dimensions.width
                )}
              >
                <Text
                  accessible={true}
                  selectable={false}
                  {...GlobalStyles.TextStyles(theme)['Get Started Text'].props}
                  style={StyleSheet.applyWidth(
                    GlobalStyles.TextStyles(theme)['Get Started Text'].style,
                    dimensions.width
                  )}
                >
                  {
                    'Want to create a “What if?” scenario?: Click What If from the Dashboard or Overview sidebar, make the desired changes and save it as the desired scenario name'
                  }
                </Text>
              </View>
              <Link
                accessible={true}
                onPress={() => {
                  try {
                    navigation.navigate('BestPracticesScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                selectable={false}
                {...GlobalStyles.LinkStyles(theme)['Link'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.LinkStyles(theme)['Link'].style,
                    {
                      color: {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.Brand.White,
                      },
                      fontFamily: {
                        minWidth: Breakpoints.Laptop,
                        value: 'Inter_400Regular',
                      },
                      fontSize: { minWidth: Breakpoints.Laptop, value: 30 },
                      marginTop: { minWidth: Breakpoints.Laptop, value: 24 },
                      textAlign: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                    }
                  ),
                  dimensions.width
                )}
                title={'Best Practices'}
              />
              {/* Link 2 */}
              <Link
                accessible={true}
                onPress={() => {
                  try {
                    navigation.navigate('DashboardScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                selectable={false}
                {...GlobalStyles.LinkStyles(theme)['Link'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.LinkStyles(theme)['Link'].style,
                    {
                      color: {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.Brand.White,
                      },
                      fontFamily: {
                        minWidth: Breakpoints.Laptop,
                        value: 'Inter_400Regular',
                      },
                      fontSize: { minWidth: Breakpoints.Laptop, value: 18 },
                      marginTop: { minWidth: Breakpoints.Laptop, value: 24 },
                      textAlign: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                    }
                  ),
                  dimensions.width
                )}
                title={'Exit to Dashboard'}
              />
            </View>
          </View>
        )}
      </>
      <>
        {!!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <ScreenSizeWarningBlock />
        )}
      </>
    </ScreenContainer>
  );
};

export default withTheme(GetStartedScreen);
